import { types } from "../action-types";

const S3_URL = process.env.REACT_APP_S3_URL || "";

const normalizeItem = (item) => {
  const profile = item?.users?.Profiles || {};
  const firstName = profile.FirstName || "";
  const lastName = profile.LastName || "";
  const pictureUrl = profile.PictureUrl;

  return {
    ...item,
    _id: item._id,
    id: item.SkillListingId,
    name: `${firstName} ${lastName}`.trim() || "Unknown",
    title: item.Title || "",
    avatar: pictureUrl
      ? pictureUrl.startsWith("http")
        ? pictureUrl
        : `${S3_URL}/${pictureUrl}`
      : null,
    initials: firstName && lastName ? `${firstName[0]}${lastName[0]}` : "?",
    online: false,
    rating: parseFloat(profile.Rating) || 0,
    reviewCount: profile.Review || 0,
    experience: profile.ExperienceLevelName || "",
    estimatedAmount: item.MinimumBid
      ? `$${item.MinimumBid}/${item.MinimumBidType || ""}`
      : "",
    location: (() => {
      const city = item.SkillListings_Cities?.[0];
      return city?.Cities?.LocationWithCountry || city?.LocationWithCountry || "";
    })(),
  };
};

const initialState = {
  loading: false,
  error: false,
  data: [],
  totalCount: 0,
};

const associatedTalentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ASSOCIATED_TALENTS_INIT:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case types.GET_ASSOCIATED_TALENTS_SUCCESS: {
      const rawList = Array.isArray(action.payload)
        ? action.payload
        : Array.isArray(action.payload?.data)
        ? action.payload.data
        : [];

      const totalCount =
        action.payload?.pagination?.totalCount ||
        rawList[0]?.totalMeta?.count?.total ||
        rawList.length;

      const normalized = rawList.map(normalizeItem);

      return {
        ...state,
        loading: false,
        error: false,
        data: normalized,
        totalCount,
      };
    }

    case types.GET_ASSOCIATED_TALENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        data: [],
        totalCount: 0,
      };

    default:
      return state;
  }
};

export default associatedTalentsReducer;
